import { render, staticRenderFns } from "./deleteProductCategory.vue?vue&type=template&id=5163a346"
import script from "./deleteProductCategory.vue?vue&type=script&lang=js"
export * from "./deleteProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports